import { Link, useLocation } from 'react-router-dom';
import { CONTACT_EMAIL } from '../config';
import '../CSS/pages.css';

function Confirmation() {
  const { state } = useLocation();
  const requestType = state?.requestType || 'service';

  return (
    <main className="page confirmation-page">
      <section className="confirmation-panel">
        <p className="eyebrow">Request received</p>
        <h1>Thank you for contacting Emmapro Logistix.</h1>
        <p>
          Your {requestType} request has been received. We will review your
          information and follow up using the contact details you provided.
        </p>
        <p>
          You can also reach us at{' '}
          <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
        </p>
        <div className="page-actions">
          <Link className="primary-action" to="/">
            Return to services
          </Link>
        </div>
      </section>
    </main>
  );
}

export default Confirmation;
